/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 *
 * Modaldialog zur Bestätigung des Container-Downloads
 * +---------------------------------------------------+
 * | Download Linde-Katalog?                           |
 * +---------------------------------------------------+
 * | [ABBRUCH]                                  [ OK ] |
 * +---------------------------------------------------+
 */

import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { ModalTitle } from "../../partials/ModalTitle";

import * as utils from "../../../basics/utils";
import * as appActions from "../../../store/actions/appActions";
import * as userActions from "../../../store/actions/userActions";
import * as iconActions from "../../../store/actions/iconActions";
import * as syncActions from "../../../store/actions/syncActions";
import * as versionActions from "../../../store/actions/versionActions";
import * as settingActions from "../../../store/actions/settingActions";
import * as portfolioActions from "../../../store/actions/portfolioActions";
import * as containerActions from "../../../store/actions/containerActions";


class DownloadConfirmModal extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'DownloadConfirmModal';

        this.wakeLock = null;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { modalDialog } = this.props.app;
        const { loginUser } = this.props.user;

        if (!modalDialog['details']) return null;

        const sVersion = modalDialog.details.version;
        const sContainer = modalDialog.details.container;

        const onConfirm = () => {
            const debug = false;

            const requestWakeLock = async () => {
                try {
                    this.wakeLock = await navigator.wakeLock.request('screen');

                    this.wakeLock.addEventListener('release', () => {
                        console.log('Wake Lock was released');
                    });
                    console.log('Wake Lock is active');
                }
                catch (err) {
                    console.error(`${err.name}, ${err.message}`);
                }
            };

            const releaseWakeLock = () => {
                console.log('releasing wakeLock');

                this.wakeLock.release();
                this.wakeLock = null;
            };

            // diese Funktion bereitet alles für den Sync vor und
            // startet dann den Sync.
            const launchSync = () => {
                console.log(`doSync(${sContainer}, ${sVersion})`);

                requestWakeLock();

                this.props.closeModalDialog();

                this.props.setPath('');

                this.props.setSyncCancel(false);

                this.props.setAppPreview(true);

                this.props.doSync(sContainer, sVersion, () => {
                    console.log('doSync(success)');

                    releaseWakeLock();

                    // = SETTINGS  ==============================================================
                    // 
                    // Einstellungen aus IndexedDB laden 
                    // 
                    // ==========================================================================
                    const containerDownload = utils.getDownload(sContainer);

                    if (containerDownload) {
                        this.props.setSettingList(containerDownload.settings);

                        this.props.setTagSettings(containerDownload.settings.tags);

                        this.props.setIconList(containerDownload.icons);
                    }
                    if (this.props.onSuccess) this.props.onSuccess();
                }, () => {
                    console.log('doSync(error)');

                    releaseWakeLock();

                    if (this.props.onError) this.props.onError();
                });
            }

            if (sVersion === 'draft') {
                // Wenn die draft-Version geladen werden soll, dann müssen immer
                // auch die json-Dateien auf dem Server generiert werden.
                debug && console.log('ContainerController: call generatePortfiolio()');
                this.props.generatePortfolio(() => {
                    debug && console.log('ContainerController:generatePortfiolio(success)');
                    launchSync();
                }, () => {
                    console.log('ContainerController:generatePortfiolio(error)');
                });
            } else {
                launchSync();
            }
        }


        const onCancel = () => {
            this.props.closeModalDialog(); // appAction.js

            //this.props.setAppPreview(true);
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        if (modalDialog.dialog !== this.component) return null;

        const sZusatz = (loginUser && loginUser.role === 'Admin') ? ` (${sVersion}-Version)` : '';
        const maxWidth = (loginUser && loginUser.role === 'Admin') ? 'md' : 'xs';

        const title = `Download Katalog ${sZusatz} ?`;


        return (
            <Dialog fullWidth={true} open={true} maxWidth={maxWidth}>
                <ModalTitle onClose={onCancel}>Download Katalog</ModalTitle>
                <DialogContent dividers>
                    <div className="flex justify-start text-2xl font-bold whitespace-nowrap">{title}</div>
                    <br />
                    <div className="flex justify-start ">Durch den Download wird der Katalog auf Ihrem Gerät gespeichert, sodass alle Inhalte offline angezeigt werden können.</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel} variant="outlined" color="default" >Abbruch</Button>
                    <div className="flex-grow"></div>
                    <Button onClick={onConfirm} variant="contained" color="primary">OK</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        icon: state.icon,
        sync: state.sync,
        version: state.version,
        settings: state.settings,
        portfolio: state.portfolio,
        container: state.container
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, userActions, iconActions, syncActions, versionActions, containerActions, portfolioActions, settingActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadConfirmModal);